import {
  HttpClient,
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideAuth } from 'angular-auth-oidc-client';
import { authOptions } from '../environments/environment';
import { appRoutes } from './app.routes';
import { metaReducers, reducers } from './app.state';
import { AuthEffects } from './features/auth/state/auth.effects';
import { HomeEffects } from './features/home/state/home.effects';
import { provideToastr } from 'ngx-toastr';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AdminEffects } from './features/admin/state/admin.effects';
import { authTokenInterceptor } from './common/interceptors/auth-token-interceptor';
import { provideDaterangepickerLocale } from 'ngx-daterangepicker-bootstrap';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localePt from '@angular/common/locales/pt';
import localeEs from '@angular/common/locales/es';
import localeIt from '@angular/common/locales/it';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (
  http: HttpClient,
) => new TranslateHttpLoader(http, 'assets/i18n/', '.json');

registerLocaleData(localeEn);
registerLocaleData(localePt);
registerLocaleData(localeEs);
registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(NgxSpinnerModule.forRoot()),
    provideRouter(appRoutes),
    provideHttpClient(withFetch(), withInterceptors([authTokenInterceptor])),
    provideClientHydration(),
    provideAuth(authOptions),
    provideAnimationsAsync(),
    provideStore(reducers, { metaReducers }),
    provideEffects(AuthEffects, HomeEffects, AdminEffects),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideToastr({
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
    }),
    provideAnimations(),
    importProvidersFrom(BrowserAnimationsModule),
    provideDaterangepickerLocale({
      separator: ' - ',
      applyLabel: 'Okay',
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
};
